import React from "react";

const Education = () => {
  const educationData = [
    {
      id: 1,
      period: "2021 - 2025",
      degree: "Bachelor of Technology",
      institution: "SRM Institute of Science and Technology",
      location: "Kattankulathur, Chennai",
      details: "Computer Science and Engineering",
      grade: "CGPA: 9.90/10",
    },
    {
      id: 2,
      period: "2020",
      degree: "12th Standard (CBSE)",
      institution: "Bright Scholar Senior Secondary School",
      location: "Sonipat, Haryana",
      details: "Physics, Chemistry, Mathematics, Computer Science",
      grade: "Percentage: 91%",
    },
    {
      id: 3,
      period: "2018",
      degree: "10th Standard (CBSE)",
      institution: "Bright Scholar Senior Secondary School",
      location: "Sonipat, Haryana",
      details: "General Studies + Computer Science",
      grade: "Percentage: 94%",
    },
  ];

  return (
    <section id="education" className="py-6 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
          Education
        </h2>

        <div className="relative">
          <div
            className="absolute left-0 md:left-1/2 transform md:translate-x-[-50%] top-0 h-full w-1 bg-blue-500"
            style={{ marginLeft: "8px" }}
          ></div>

          <div className="space-y-8">
            {educationData.map((item, index) => (
              <div
                key={item.id}
                className="relative flex flex-col md:flex-row md:items-center md:justify-between"
              >
                <div className="absolute left-0 md:left-1/2 transform md:translate-x-[-50%] w-4 h-4 rounded-full bg-blue-600 border-4 border-white z-10 shadow-md"></div>

                {index % 2 === 0 ? (
                  <>
                    <div className="ml-8 md:ml-0 md:w-[45%] p-5 bg-white rounded-lg border border-gray-200 shadow-md hover:shadow-lg transition-shadow duration-300">
                      <h3 className="text-xl font-bold text-gray-800 mb-2">
                        {item.degree}
                      </h3>
                      <h4 className="text-lg font-semibold text-gray-700">
                        {item.institution}
                      </h4>
                      <p className="text-gray-600 italic mb-2">
                        {item.location}
                      </p>
                      <p className="text-gray-700 mb-1">{item.details}</p>
                      <p className="text-gray-700 font-medium">{item.grade}</p>
                    </div>

                    <div className="hidden md:flex md:w-[45%] items-center justify-start">
                      <span className="bg-blue-100 text-blue-800 text-lg font-medium px-4 py-2 rounded-lg shadow-sm">
                        {item.period}
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="hidden md:flex md:w-[45%] items-center justify-end">
                      <span className="bg-blue-100 text-blue-800 text-lg font-medium px-4 py-2 rounded-lg shadow-sm">
                        {item.period}
                      </span>
                    </div>

                    <div className="ml-8 md:ml-0 md:w-[45%] p-5 bg-white rounded-lg border border-gray-200 shadow-md hover:shadow-lg transition-shadow duration-300">
                      <h3 className="text-xl font-bold text-gray-800 mb-2">
                        {item.degree}
                      </h3>
                      <h4 className="text-lg font-semibold text-gray-700">
                        {item.institution}
                      </h4>
                      <p className="text-gray-600 italic mb-2">
                        {item.location}
                      </p>
                      <p className="text-gray-700 mb-1">{item.details}</p>
                      <p className="text-gray-700 font-medium">{item.grade}</p>
                    </div>
                  </>
                )}

                <div className="ml-8 mt-2 md:hidden">
                  <span className="bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded">
                    {item.period}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
